import React from 'react';
import Utils from '../utils';
import { UpgradeMessage } from './UpgradeMessage.component';

const { BillingPlans } = Utils;
const { prettyPrintPlan } = BillingPlans;

interface UpgradePlanUsersContentProps {
	data: {
		upgradePlan?: {
			Name: string;
			Price: number;
			MaxAllowedUsers?: number;
		};
	};
}

const UpgradePlanUsersContent = ({ data }: UpgradePlanUsersContentProps) => {
	const { upgradePlan = {} as NonNullable<typeof data.upgradePlan> } = data;
	const { Name, Price, MaxAllowedUsers } = upgradePlan;

	return (
		<div className="default-upgrade-content">
			<div className="left-content">
				<UpgradeMessage>
					<p>
						Upgrade to {prettyPrintPlan(Name)} Plan to receive {MaxAllowedUsers}{' '}
						user seats, plus...
					</p>
				</UpgradeMessage>
				<div className="plan-info">
					<ul>
						<li>
							Proof of delivery services like Registered and Certified Mail®
						</li>
						<li>Tracking and notification emails</li>
						<li>Access to {MaxAllowedUsers} account users</li>
						<li>Mailing and shipping analytics and reports</li>
					</ul>
				</div>
				<div className="price-panel">
					<p className="plan-name">
						<strong>{prettyPrintPlan(Name)}</strong>
					</p>
					<p className="plan-price">
						<strong>${Price}</strong> / month
					</p>
				</div>
			</div>
		</div>
	);
};

export default UpgradePlanUsersContent;
